/*
 * Screenlux Lead Flow loader: the only Lead Flow script on every page. It holds
 * the activation gate and injects the full widget (assets/leadflow.js, from
 * window.slxLeadFlow.src) only when a flow can show on this page:
 * - right away for provider 'screenlux', ?leadflow=1 (sticky for the session,
 *   ?leadflow=0 clears it), ?leadflow_open / ?leadflow_flow / ?leadflow_preview,
 *   a #leadflow-<key> hash, or an embed mount ([data-leadflow-embed]);
 * - otherwise on the first interaction with a trigger (a[href^="#leadflow-"],
 *   [data-leadflow-open], plus a[href^="#heyflow-"] under the legacy gate):
 *   hover, focus or touch starts the download, and a click is held and
 *   replayed on the same element once the widget runs (if it fails to load,
 *   the replay does what the link would have done without it).
 * slxLeadFlow.open() calls are queued and replayed; slxLeadFlow.on() works
 * before the widget loads. Keep the gate in step with leadflow.js (LEGACY,
 * TRIG_SEL, triggerKey, mountAll).
 */
(function () {
  'use strict';

  var W = window;
  var D = document;
  if (W.__slxLeadFlowInit) return; // the widget is already on the page
  var BOOT = W.slxLeadFlow && typeof W.slxLeadFlow === 'object' ? W.slxLeadFlow : (W.slxLeadFlow = {});
  if (BOOT.__loader) return;
  BOOT.__loader = true;

  var SELF = (D.currentScript && D.currentScript.src) || '';
  var SRC = BOOT.src || (/leadflow-loader\.js/.test(SELF) ? SELF.replace(/leadflow-loader\.js/, 'leadflow.js') : '');
  var FORCE_KEY = 'slx_lf_force';
  var KEY_RE = /^[a-z0-9][a-z0-9-]{1,39}$/;
  var HASH_RE = /^#leadflow-[a-z0-9][a-z0-9-]{1,39}$/;

  var params = null;
  try { params = new URLSearchParams(W.location.search); } catch (e) { params = null; }
  function qp(k) { return params ? params.get(k) : null; }

  var forced = qp('leadflow') === '1';
  try {
    if (forced) W.sessionStorage.setItem(FORCE_KEY, '1');
    else if (qp('leadflow') === '0') W.sessionStorage.removeItem(FORCE_KEY);
    else forced = W.sessionStorage.getItem(FORCE_KEY) === '1';
  } catch (e) {}
  var LEGACY = BOOT.provider === 'screenlux' || forced;
  var TRIG_SEL = 'a[href^="#leadflow-"],[data-leadflow-open]' + (LEGACY ? ',a[href^="#heyflow-"]' : '');

  // Mirrors leadflow.js triggerKey(): only hold clicks the widget will handle.
  function handles(a) {
    if (a.hasAttribute('data-leadflow-open')) {
      var k = a.getAttribute('data-leadflow-flow');
      return k ? KEY_RE.test(k) || k === '@default' : LEGACY;
    }
    var href = a.getAttribute('href') || '';
    return HASH_RE.test(href) || (LEGACY && href.indexOf('#heyflow-') === 0);
  }
  function findTrigger(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest(TRIG_SEL) : null;
    return a && handles(a) ? a : null;
  }

  var state = 0; // 0 idle, 1 loading, 2 running, 3 failed
  var held = null;
  var calls = [];

  function replay(a) {
    try {
      if (!D.documentElement.contains(a)) return;
      if (typeof a.click === 'function') a.click();
      else a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: W }));
    } catch (e) {}
  }
  function settle(ok) {
    state = ok && W.__slxLeadFlowInit ? 2 : 3;
    var a = held;
    var q = calls;
    held = null;
    calls = [];
    if (state === 2) {
      q.forEach(function (c) { try { W.slxLeadFlow.open.apply(W.slxLeadFlow, c); } catch (e) {} });
    }
    if (a) replay(a); // running: the widget's own click handler takes it
  }
  function load() {
    if (state) return;
    if (!SRC) { settle(false); return; }
    state = 1;
    try {
      var s = D.createElement('script');
      s.src = SRC;
      s.async = true;
      s.onload = function () { settle(true); };
      s.onerror = function () { settle(false); };
      (D.head || D.documentElement).appendChild(s);
    } catch (e) { settle(false); }
  }

  W.addEventListener('click', function (e) {
    try {
      if (state >= 2 || (e.button && e.button !== 0)) return;
      var a = findTrigger(e);
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      held = a;
      load();
    } catch (err) {}
  }, true);

  var warm = function (e) {
    try { if (!state && findTrigger(e)) load(); } catch (err) {}
  };
  D.addEventListener('pointerover', warm, { passive: true });
  D.addEventListener('touchstart', warm, { passive: true });
  D.addEventListener('focusin', warm);
  W.addEventListener('hashchange', function () {
    if (HASH_RE.test(W.location.hash || '')) load();
  });

  if (typeof BOOT.open !== 'function') {
    BOOT.open = function () {
      calls.push(Array.prototype.slice.call(arguments));
      load();
    };
  }
  if (typeof BOOT.close !== 'function') BOOT.close = function () { calls = []; held = null; };
  if (typeof BOOT.on !== 'function') {
    BOOT.on = function (type, fn) { // same as leadflow.js, which replaces it
      if (typeof fn !== 'function') return function () {};
      var h = function (e) {
        var d = e && e.detail;
        if (!d) return;
        if (!type || type === '*' || d.event === type || d.event === 'leadflow_' + type) {
          try { fn(d); } catch (err) {}
        }
      };
      W.addEventListener('slx-leadflow', h);
      return function () { W.removeEventListener('slx-leadflow', h); };
    };
  }

  function needed() {
    if (LEGACY) return true;
    if (qp('leadflow_open') || qp('leadflow_flow') || qp('leadflow_preview')) return true;
    if (HASH_RE.test(W.location.hash || '')) return true;
    return !!D.querySelector('[data-leadflow-embed]');
  }
  function boot() { try { if (!state && needed()) load(); } catch (e) {} }

  // Theme editor: a re-rendered section can add an embed mount later.
  D.addEventListener('shopify:section:load', boot);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
